import React from 'react'

export default function NotFound() {
  return (
    <div className="flex items-center justify-center ">
      <span>notFound</span></div>
  )
}
